import { middlewares } from "./middlewares";

export const configs = {
  linkMiddlewares: middlewares,
};
